import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import BlockchainUrlList from "./BlockchainUrlList";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import BlockchainUrlFilter from "./BlockchainUrlFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import DialogModal from "../../elements/dialogModal/DialogModal";
import TwoFa from "../../elements/twoFa/TwoFa";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import CreateBlockchainUrlButton from "../../elements/blockchainUrl/CreateBlockchainUrlButton";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBlockchainUrlWrapper } from "../styledBlockchaindUrl";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const BlockchainUrlContainer = () => {
  const { t } = useTranslation("blockchainUrlPage");
  const [blockchainUrls, setBlockchainUrls] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    id: null
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currency.asset": checkFilterItem(history, "currency.asset", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBlockchainUrls = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/currency-settings" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setBlockchainUrls(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleRemoveBlockchainUrl = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.delete("/api/currency-settings/" + submitData.id, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.deleteMessage") });
      }
    }).catch(error => {
      setOpen(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchBlockchainUrls();
  }, [filterData, notification]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };
  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("table.twoFa")}
        content={<TwoFa
          handleSubmit={handleRemoveBlockchainUrl}
          error={error}
        />}
      />
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledBlockchainUrlWrapper>
          <div className="blockchain-url-head">
            <BlockchainUrlFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <CreateBlockchainUrlButton
              notification={notification}
              setNotification={setNotification}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <BlockchainUrlList
            blockchainUrls={blockchainUrls}
            setOpen={setOpen}
            submitData={submitData}
            setSubmitData={setSubmitData}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledBlockchainUrlWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default BlockchainUrlContainer;